import Ship from './ship';
import Weapon, { WeaponParams } from './weapon';
import Particle, { ParticleParams } from '../particle';
import { randomInArray } from '../../../utils/array';
import { round } from '../../../utils/math';

export interface ReactorParams extends WeaponParams {
  particleAngleVariation?: number;
  particleParams?: ParticleParams;
}

export default class Reactor extends Weapon implements ReactorParams {
  particleAngleVariation = 30;
  particleParams?: ParticleParams;

  lookAngle = 270; // by default: reactor push toward the rear of the ship
  width = 4;
  range = 5;
  timeBetweenShots = 24; // ~ every 2 frames

  constructor(params: ReactorParams) {
    super(params);
    this.applyParams(params);
  }

  equipTo(ship: Ship): Ship {
    super.equipTo(ship);
    this.ship.reactors.push(this);
    return this.ship;
  }

  update(modifier: number): Reactor {
    this.updatePosition();
    this.updateLookAngle();
    this.updateCooldown(modifier);
    this.emitParticle();
    return this;
  }

  draw(): CanvasRenderingContext2D {
    return this.context;
  }

  emitParticle(): void {
    if (this.ship.isInWarFog || this.timeBeforeNextShot > 0)
      return;

    const { ship, x, y, width, range, particleParams, particleAngleVariation } = this;
    const { scene, context } = ship;

    let moveAngle = this.lookAngle;
    moveAngle += (round(Math.random() * particleAngleVariation) * randomInArray([-1, 1]));

    new Particle({
      ...particleParams,
      scene,
      context,
      x,
      y,
      width: width * ship.moveSpeed / ship.moveSpeedMax, // the faster, the bigger
      range,
      moveAngle,

    } as ParticleParams).create();

  }
}
